import React, { forwardRef, useState, useEffect } from "react";
import { Row, Col } from "antd";
import { InputItem, DatePickerItem } from "../../../components/forms/FormItems";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import SwitchItem from "../../../components/forms/SwitchItem";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import { useSelector } from "react-redux";

const Authorities = forwardRef((props, ref) => {
  const { activeEmployee } = props;
  const changedValues = useSelector(
    (state) => state.employeeDetails.changedItems.values
  );

  const [isVisaNumber, setIsVisaNumber] = useState();

  useEffect(() => {
    const num =
      changedValues["foreign.visa_number"] !== undefined
        ? changedValues["foreign.visa_number"]
        : activeEmployee.foreign.visa_number;
    setIsVisaNumber(num && num !== "" ? true : false);
  }, [activeEmployee.foreign, changedValues]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.employees.authorities" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="foreign.country_enter_date"
                  category="employee"
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="foreign.exited_country_at"
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="foreign.insurance_company_id"
                  category="employee"
                  settingsdataName={"system_tables/insurance_companies"}
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="foreign.medical_insurance_expired_at"
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem name="foreign.visa_number" category="employee" />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <DatePickerItem
                  required={isVisaNumber}
                  name="foreign.visa_expired_at"
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="foreign.file_issued"
                  category="employee"
                  trueFalse={true}
                />
              </div>
              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="foreign.file_issued_at"
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="foreign.interior_ministry_case_number"
                  category="employee"
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="foreign.has_assignment_letter"
                  category="employee"
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="foreign.tourist_with_license"
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Authorities;
